import { createSelector } from 'reselect';

const getStatus = (state) => state.status;

const statusSelector = createSelector(
    [getStatus], (status) => status.toJS()
);

export default statusSelector;
